export var CounterBadgePriority;
(function (CounterBadgePriority) {
    CounterBadgePriority["primary"] = "primary";
    CounterBadgePriority["secondary"] = "secondary";
})(CounterBadgePriority || (CounterBadgePriority = {}));
//# sourceMappingURL=types.js.map